export default {
    namespaced: true,

    state: {
        balances: null,
    },

    actions: {
        getBalances({ commit }) {
            return axios.get('/api/contacts/arrears')
            .then((response) => {
                commit('setBalances', response.data.data);
            })
            .catch(() => {
                commit('setBalances', null);
            });
        },
    },

    mutations: {
        setBalances(state, balances) {
            state.balances = balances;
        },
    },
};